
import {
  defineComponent,
  defineAsyncComponent,
  shallowRef,
  computed,
} from 'vue'
import { useI18n } from 'vue-i18n'

const ServicesContactForm = defineAsyncComponent(() =>
  import('@/components/components-services/ServicesContactForm.vue'),
)
const ServicesFooter = defineAsyncComponent(() =>
  import('@/components/components-services/ServicesFooter.vue'),
)
const HeroMTAgency = defineAsyncComponent(() =>
  import('@/components/mt-agency/Hero.vue'),
)

const GoogleSection = defineAsyncComponent({
  loader: () => import('@/components/mt-agency/GoogleSection.vue'),
  errorComponent: { template: '<div>Error loading GoogleSection</div>' },
  loadingComponent: { template: '<div>Loading GoogleSection...</div>' },
})
const FacebookSection = defineAsyncComponent(() =>
  import('@/components/mt-agency/FacebookSection.vue'),
)

export default defineComponent({
  name: 'MTAgencyView',
  components: {
    HeroMTAgency,
    ServicesContactForm,
    ServicesFooter,
    GoogleSection,
    FacebookSection,
  },
  setup() {
    const { t, tm } = useI18n()

    const selected = shallowRef('google')

    const advantagesList = computed(() => {
      const itemsObj = tm('landingMTShop.advantages.items') as Record<
        string,
        any
      >
      return Object.values(itemsObj)
    })

    const accountList = computed(() => {
      const itemsObj = tm('landingMTShop.goods.list') as Record<string, any>
      return Object.values(itemsObj)
    })

    const handlePlatformChange = (platform: string) => {
      selected.value = platform
    }

    return {
      t,
      selected,
      advantagesList,
      accountList,
      handlePlatformChange,
    }
  },
})
